import React from "react";
import { Drawer, List, ListItem, ListItemText, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const MobileDrawer = ({ menuItems, drawerOpen, toggleDrawer }) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: { width: "90vw" },
      }}
    >
      <List>
        {menuItems.map((item, index) => (
          <ListItem
            button
            key={index}
            component={Link}
            to={item.path}
            onClick={toggleDrawer(false)}
            sx={{
              "&:hover": {
                backgroundColor: theme.palette.action.hover,
              },
            }}
          >
            <ListItemText
              primary={item.text}
              sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default MobileDrawer;